import { Fill, Stroke, Style, Text } from "ol/style";
import { extractTags } from "./propertyExtraction";
import { styleBySection } from "./util/stepSectionStyle";
import { laneCountDescriptor } from "./util/laneCount.mjs";
import {
  ROAD_CLASS_UNTAGGED,
  Z_RESTRICTION,
  roadClass,
  roadClassStroke,
} from "./util/roadClass";

// The RM Lanes rows: lane count as colour, written along the line as
// total/F#/B#/BW# (util/laneCount.mjs), one section per change of any of them.
const LANE_COUNT_WIDTH = 6;
const LABEL_FONT = "bold 13px sans-serif";
// Same selection treatment as the Restrictions view: a halo under the way's own
// stroke, so the count colour and label stay readable while selected.
const HALO_EXTRA_PX = 4;
const HOVER_HALO = "white";
const CLICK_HALO = "#00b8d9";

export function getLaneCountStyleNormal(feature) {
  return getLaneCountStyle(feature, false, false);
}

export function getLaneCountStyleClick(feature) {
  return getLaneCountStyle(feature, true, false);
}

export function getLaneCountStyleHover(feature) {
  return getLaneCountStyle(feature, false, true);
}

function getLaneCountStyle(feature, click, hover) {
  // Ways with no `highway=` are dropped, as in the Lanes view: the basemap never
  // called them roads.
  const cls = roadClass(feature);
  if (cls === ROAD_CLASS_UNTAGGED) return [];
  const plain = roadClassStroke(cls);
  return styleBySection(
    feature,
    extractTags(feature),
    (tags) => laneCountDescriptor(tags) ?? plain,
    (descriptor, geometry) => toStyles(descriptor, geometry, click, hover),
  );
}

function toStyles(descriptor, geometry, click, hover) {
  const counted = "label" in descriptor;
  const zIndex = counted ? Z_RESTRICTION : descriptor.zIndex;
  const width = counted ? LANE_COUNT_WIDTH : descriptor.width;
  const styles = [];
  if (click || hover) {
    styles.push(
      new Style({
        geometry,
        zIndex,
        stroke: new Stroke({
          color: click ? CLICK_HALO : HOVER_HALO,
          width: width + HALO_EXTRA_PX,
        }),
      }),
    );
  }
  styles.push(
    new Style({
      geometry,
      zIndex,
      stroke: new Stroke({ color: descriptor.color, width }),
      text: counted
        ? new Text({
            text: descriptor.label,
            placement: "line",
            font: LABEL_FONT,
            fill: new Fill({ color: "#222" }),
            stroke: new Stroke({ color: "white", width: 3 }),
          })
        : undefined,
    }),
  );
  return styles;
}
